// Import scripts
import './js/CreditReport.js';

// Import CSS
import './scss/main.scss';

// Do on DOM ready
document.addEventListener( 'DOMContentLoaded', () => {});